/**
 * B.3 — kayıt kaynağı yakalama.
 *
 * NEDEN VAR
 * ---------
 * 27 Ağustos'ta bir paylaşımla 22 kişi geldi ve hiçbiri içerik üretmedi.
 * Hangi paylaşım olduğunu bilmiyoruz — çünkü kaynağı hiç kaydetmiyorduk.
 * Reklam akarken kaydedilmeyen her kayıt, nereden geldiği **sonsuza kadar
 * kayıp** bir satır demek. Bu yüzden değeri saat başı azalan bir iş.
 *
 * NEDEN localStorage
 * ------------------
 * Kaynak reklamın açtığı İLK sayfada URL'de bulunuyor, ama kullanıcı çoğu
 * zaman hemen üye olmuyor: geziyor, kapatıyor, ertesi gün dönüyor. Değeri
 * o an saklamazsak kayıt anında elimizde olmaz.
 *
 * OTURUM DEĞİL, 30 GÜN
 * --------------------
 * `sessionStorage` sekme kapanınca siliniyor ve tam da tipik davranışı
 * (bak, kapat, sonra dön) kaçırırdı. 30 gün sonra düşüyor: aylar önceki
 * bir reklamı bugünkü kaydın sebebi saymak, veri olmamasından beter.
 *
 * İLK KAYNAK KAZANIR
 * ------------------
 * Zaten bir kaynak varsa üzerine yazılmıyor. Kullanıcıyı getiren şey ilk
 * dokunuştur; sonradan bir paylaşım linkine tıklaması onu "o paylaşımdan
 * geldi" yapmaz.
 */
const ANAHTAR = "sk_signup_source";
const ZAMAN_ANAHTARI = "sk_signup_source_ts";
const OMUR_MS = 30 * 24 * 60 * 60 * 1000;

// Sunucudaki `_kaynagi_temizle` ile AYNI kural (auth/routes.py). İstemcide
// de temizliyoruz ki depoya çöp yazılmasın; sunucu yine de kendi denetimini
// yapıyor — istemci denetimi bir kolaylık, güvenlik sınırı değil.
const DESEN = /^[a-z0-9_.-]{1,40}$/;

function temizle(ham) {
  if (!ham || typeof ham !== "string") return null;
  const d = ham.trim().toLowerCase();
  return DESEN.test(d) ? d : null;
}

/** URL'de kaynak varsa sakla. Uygulama açılışında bir kez çağrılır. */
export function kaynagiYakala(arama) {
  try {
    const p = new URLSearchParams(
      arama !== undefined ? arama : window.location.search
    );
    const kaynak = temizle(p.get("utm_source") || p.get("ref"));
    if (!kaynak) return null;
    // İlk kaynak kazanır.
    if (localStorage.getItem(ANAHTAR)) return localStorage.getItem(ANAHTAR);
    localStorage.setItem(ANAHTAR, kaynak);
    localStorage.setItem(ZAMAN_ANAHTARI, String(Date.now()));
    return kaynak;
  } catch (e) {
    // Gizli sekme / depolama kapalı. Kaynak kaydı hiçbir akışı bloklamamalı.
    return null;
  }
}

/** Kayıt yüküne eklenecek değer. Yoksa ya da bayatsa null. */
export function kaynagiOku() {
  try {
    const kaynak = temizle(localStorage.getItem(ANAHTAR));
    if (!kaynak) return null;
    const ts = Number(localStorage.getItem(ZAMAN_ANAHTARI) || 0);
    if (!ts || Date.now() - ts > OMUR_MS) {
      localStorage.removeItem(ANAHTAR);
      localStorage.removeItem(ZAMAN_ANAHTARI);
      return null;
    }
    return kaynak;
  } catch (e) {
    return null;
  }
}

/** Test için. */
export function kaynagiUnut() {
  try {
    localStorage.removeItem(ANAHTAR);
    localStorage.removeItem(ZAMAN_ANAHTARI);
  } catch (e) {
    /* yoksay */
  }
}
